import type { FormatterFactory } from '../types';

export const text: FormatterFactory = () => ({
  toText: (value) => (value == null ? '' : String(value)),
});
